/**
 * DỮ LIỆU & BỘ TÍNH TOÁN CƠ CHẾ LƯƠNG THƯỞNG QUẦY THUỐC
 * Áp dụng cho: Nhà thuốc, quầy thuốc độc lập và chuỗi nhỏ
 * Căn cứ pháp lý: Nghị định 293/2025/NĐ-CP (Lương tối thiểu vùng từ 01/01/2026)
 * Xuất xứ: Thế Thảo Pharma · Nhà Thuốc & Dược Sĩ 5.0
 */

export const SALARY_LIB = {
  capNhat: '01/2026',
  vung: {
    1: 5310000,
    2: 4730000,
    3: 4140000,
    4: 3700000,
  },
  vungTen: {
    1: 'Vùng I — 5.310.000 đ',
    2: 'Vùng II — 4.730.000 đ',
    3: 'Vùng III — 4.140.000 đ',
    4: 'Vùng IV — 3.700.000 đ',
  },

  bacHS: [1.00, 1.09, 1.19, 1.30, 1.42],
  bacDK: [
    'Mới vào hoặc dưới 1 năm kinh nghiệm. Hết thử việc, thuộc quy trình bán hàng và ghi chép sổ sách.',
    'Đủ 1 năm ở bậc 1, KPI 3 tháng liên tiếp từ 80 điểm, tự đứng quầy được một mình một ca.',
    'Đủ 12 tháng ở bậc 2, KPI 6 tháng gần nhất bình quân từ 85, tư vấn được nhóm hàng 2 không cần hỏi ai.',
    'Đủ 18 tháng ở bậc 3, KPI bình quân từ 88, kèm được người mới, không để xảy ra sai sót chuyên môn bị lập biên bản.',
    'Đủ 18 tháng ở bậc 4, KPI bình quân từ 90, chủ động xây được nhóm hàng chiến lược và giữ được khách quen.',
  ],

  viTri: [
    {
      id: 'chu',
      ten: 'Chủ đứng quầy (kiêm quản lý)',
      hs: 2.20,
      loai: 'ban',
      defaultN: 0,
      defaultBac: 5,
      ban: 1.00,
      abil: [0.90, 1.20, 1.30],
      cchn: 1,
      bang: 'cd',
      mo: 'Chỉ điền nếu chủ tự trả cho mình một mức lương như mọi vị trí khác. Nếu chủ hưởng bằng lợi nhuận thì để 0.',
    },
    {
      id: 'dsptcm',
      ten: 'Dược sĩ phụ trách chuyên môn',
      hs: 2.05,
      loai: 'ban',
      defaultN: 1,
      defaultBac: 4,
      ban: 1.00,
      abil: [0.80, 1.30, 1.40],
      cchn: 1,
      bang: 'dh',
      mo: 'Bắt buộc phải có và có mặt trong toàn bộ thời gian quầy mở cửa theo quy định GPP.',
    },
    {
      id: 'dstv',
      ten: 'Dược sĩ bán hàng, tư vấn',
      hs: 1.55,
      loai: 'ban',
      defaultN: 2,
      defaultBac: 3,
      ban: 1.00,
      abil: [0.90, 1.25, 1.20],
      cchn: 0,
      bang: 'cd',
      mo: 'Lực lượng trực tiếp tạo ra lãi gộp nhóm 2 (hàng tư vấn) và nhóm 3 (chiến lược).',
    },
    {
      id: 'nvbh',
      ten: 'Nhân viên bán hàng, thu ngân',
      hs: 1.25,
      loai: 'ban',
      defaultN: 1,
      defaultBac: 2,
      ban: 0.75,
      abil: [1.30, 0.60, 0.50],
      cchn: 0,
      bang: 'tc',
      mo: 'Chủ yếu xử lý hàng khách hỏi đúng tên và thực hiện khâu thu ngân thanh toán.',
    },
    {
      id: 'kho',
      ten: 'Nhân viên kho vận',
      hs: 1.10,
      loai: 'ho',
      defaultN: 1,
      defaultBac: 2,
      ban: 0,
      abil: [0, 0, 0],
      cchn: 0,
      bang: 'tc',
      mo: 'Nhập xuất, kiểm hạn dùng, bảo quản nhiệt ẩm, kiểm kê và soạn hàng hóa.',
    },
    {
      id: 'ketoan',
      ten: 'Kế toán',
      hs: 1.30,
      loai: 'ho',
      defaultN: 0,
      defaultBac: 3,
      ban: 0,
      abil: [0, 0, 0],
      cchn: 0,
      bang: 'cd',
      mo: 'Sổ sách, hoá đơn, quản lý công nợ, chiết khấu nhà cung cấp. Quầy nhỏ có thể thuê ngoài, để 0.',
    },
  ],

  heSo3P: 0.82,
  phucCap: {
    cchn: 1500000,
    dh: 1200000,
    cd: 600000,
    tc: 300000,
    tnNam: 100000,
    tnMax: 1000000,
  },
  bangTen: {
    dh: 'Đại học dược',
    cd: 'Cao đẳng dược',
    tc: 'Trung cấp dược',
    '': 'Chưa có bằng chuyên môn',
  },

  kpiThang: [
    { min: 95, hs: 1.30, mo: 'Xuất sắc' },
    { min: 90, hs: 1.15, mo: 'Tốt' },
    { min: 80, hs: 1.00, mo: 'Đạt' },
    { min: 70, hs: 0.85, mo: 'Cần cải thiện' },
    { min: 60, hs: 0.65, mo: 'Yếu, nhắc nhở bằng văn bản' },
    { min: 0, hs: 0.00, mo: 'Không đạt, không xét thưởng tháng đó' },
  ],

  kpiBan: [
    ['Doanh thu cá nhân so với mức giao', 30],
    ['Lãi gộp tạo ra và tỷ trọng nhóm 2 + nhóm 3', 25],
    ['Tuân thủ chuyên môn: bán đúng đơn, ghi chép, không tự ý bán kháng sinh', 20],
    ['Khách quay lại và số khách được chăm sóc sau bán', 15],
    ['Kỷ luật, vệ sinh quầy, kiểm kê và theo dõi hạn dùng', 10],
  ],
  kpiKho: [
    ['Chính xác nhập xuất, tồn thực khớp tồn sổ', 30],
    ['Kiểm soát hạn dùng, tỷ lệ hàng cận date và hàng huỷ', 25],
    ['Sắp xếp đúng nguyên tắc FEFO, bảo quản đúng nhiệt độ độ ẩm', 20],
    ['Tốc độ soạn hàng và giao hàng đúng hẹn', 15],
    ['Vệ sinh, an toàn kho, hồ sơ bảo quản đầy đủ', 10],
  ],
  kpiKeToan: [
    ['Sổ sách, hoá đơn, chứng từ hoàn tất đúng hạn', 30],
    ['Khớp quỹ tiền mặt và công nợ nhà cung cấp', 25],
    ['Hồ sơ thuế và hồ sơ GPP đầy đủ, sẵn sàng hậu kiểm', 20],
    ['Báo cáo phục vụ điều hành nộp đúng ngày', 15],
    ['Bảo mật số liệu và kỷ luật lao động', 10],
  ],

  nguong: {
    dtTot: 10,
    dtXau: 14, // quỹ lương / doanh thu (%)
    lgTot: 45,
    lgXau: 60, // quỹ lương / lãi gộp (%)
    dtNguoiTot: 100,
    dtNguoiXau: 70, // doanh thu mỗi người (triệu)
    thuongThap: 12,
    thuongCao: 45, // tỷ trọng thưởng trong thu nhập (%)
  },
};

export const DEFAULT_SALARY_INPUTS = {
  dt: 500, // Doanh thu trung bình tháng (triệu)
  ngay: 30, // Ngày mở cửa / tháng
  gio: 14, // Giờ mở cửa / ngày
  vung: '3', // Vùng lương tối thiểu
  chu: 'part', // 'full' | 'part' | 'no'
  chiPhi: 25, // Chi phí cố định khác (triệu)
  w1: 55, // Tỷ trọng DT nhóm 1 (%)
  w2: 30, // Tỷ trọng DT nhóm 2 (%)
  w3: 15, // Tỷ trọng DT nhóm 3 (%)
  m1: 12, // Biên lãi gộp nhóm 1 (%)
  m2: 28, // Biên lãi gộp nhóm 2 (%)
  m3: 42, // Biên lãi gộp nhóm 3 (%)
  rate1: 5, // Tỷ lệ trích thưởng nhóm 1 (%)
  rate2: 12, // Tỷ lệ trích thưởng nhóm 2 (%)
  rate3: 17, // Tỷ lệ trích thưởng nhóm 3 (%)
  ht: 70, // Mức hưởng của tuyến sau so với bán hàng (%)
  mct: 100, // Mức chi trả so với chuẩn tham chiếu (%)
  mo: '3P', // Mô hình 2P hoặc 3P
  kpi: true, // Gắn thẻ điểm KPI
  cn: true, // Quầy tách được doanh số cá nhân
  positions: {
    chu: { n: 0, bac: 5 },
    dsptcm: { n: 1, bac: 4 },
    dstv: { n: 2, bac: 3 },
    nvbh: { n: 1, bac: 2 },
    kho: { n: 1, bac: 2 },
    ketoan: { n: 0, bac: 3 },
  },
};

/* ============================================================
   TIỆN ÍCH ĐỊNH DẠNG SỐ VÀ TIỀN TỆ
   ============================================================ */
export function r0(x) {
  return Math.round(Number(x) || 0);
}

export function fmtMoney(x) {
  return `${r0(x).toLocaleString('vi-VN')} đ`;
}

export function fmtTrieu(x, d = 1) {
  const v = (Number(x) || 0) / 1e6;
  return `${v.toFixed(d).replace('.', ',')} tr`;
}

export function fmtPercent(x, d = 1) {
  const v = Number(x) || 0;
  return `${v.toFixed(d).replace('.', ',')}%`;
}

export function clamp(x, a, b) {
  return Math.max(a, Math.min(b, x));
}

export function getKpiHs(diem) {
  for (let i = 0; i < SALARY_LIB.kpiThang.length; i++) {
    if (diem >= SALARY_LIB.kpiThang[i].min) return SALARY_LIB.kpiThang[i].hs;
  }
  return 0;
}

export function getKpiDesc(diem) {
  for (let i = 0; i < SALARY_LIB.kpiThang.length; i++) {
    if (diem >= SALARY_LIB.kpiThang[i].min) return SALARY_LIB.kpiThang[i].mo;
  }
  return '';
}

/* ============================================================
   THUẬT TOÁN TÍNH TOÁN CƠ CHẾ LƯƠNG THƯỞNG
   ============================================================ */
export function computeSalaryMechanism(inputs) {
  const I = {
    dt: (parseFloat(inputs.dt) || 0) * 1e6,
    ngay: clamp(parseInt(inputs.ngay, 10) || 30, 1, 31),
    gio: clamp(parseFloat(inputs.gio) || 14, 1, 24),
    vung: String(inputs.vung || '3'),
    chu: inputs.chu || 'part',
    chiPhi: (parseFloat(inputs.chiPhi) || 0) * 1e6,
    w: [parseFloat(inputs.w1) || 0, parseFloat(inputs.w2) || 0, parseFloat(inputs.w3) || 0],
    m: [parseFloat(inputs.m1) || 0, parseFloat(inputs.m2) || 0, parseFloat(inputs.m3) || 0],
    rate: [parseFloat(inputs.rate1) || 0, parseFloat(inputs.rate2) || 0, parseFloat(inputs.rate3) || 0],
    ht: parseFloat(inputs.ht) || 70,
    mct: parseFloat(inputs.mct) || 100,
    mo: inputs.mo || '3P',
    kpi: Boolean(inputs.kpi),
    cn: Boolean(inputs.cn),
    positions: inputs.positions || DEFAULT_SALARY_INPUTS.positions,
  };

  const R = { I };
  const LTTV = SALARY_LIB.vung[I.vung] || 4140000;
  R.LTTV = LTTV;

  // 1. Nhóm hàng
  const tongW = I.w[0] + I.w[1] + I.w[2];
  R.tongW = tongW;
  const wn = tongW > 0 ? [I.w[0] / tongW, I.w[1] / tongW, I.w[2] / tongW] : [1, 0, 0];
  R.wn = wn;
  R.dtN = [I.dt * wn[0], I.dt * wn[1], I.dt * wn[2]];
  R.lgN = [
    (R.dtN[0] * I.m[0]) / 100,
    (R.dtN[1] * I.m[1]) / 100,
    (R.dtN[2] * I.m[2]) / 100,
  ];
  R.lg = R.lgN[0] + R.lgN[1] + R.lgN[2];
  R.bien = I.dt > 0 ? (R.lg / I.dt) * 100 : 0;
  R.thuongN = [
    (R.lgN[0] * I.rate[0]) / 100,
    (R.lgN[1] * I.rate[1]) / 100,
    (R.lgN[2] * I.rate[2]) / 100,
  ];

  // 2. Danh sách nhân sự giả lập
  const vtList = SALARY_LIB.viTri.map((v) => {
    const pos = I.positions[v.id] || { n: v.defaultN, bac: v.defaultBac };
    return {
      id: v.id,
      ten: v.ten,
      hs: v.hs,
      loai: v.loai,
      ban: v.ban,
      abil: v.abil,
      cchn: v.cchn,
      bang: v.bang,
      mo: v.mo,
      n: Math.max(0, parseInt(pos.n, 10) || 0),
      bacTB: clamp(parseInt(pos.bac, 10) || v.defaultBac, 1, 5),
    };
  });
  R.vtList = vtList;

  const ladderBac = [0, -1, 1, 0, -1, 1, 0];
  const ladderKPI = [92, 86, 82, 88, 78, 90, 84];
  const ns = [];
  let stt = 0;

  for (let i = 0; i < vtList.length; i++) {
    const v = vtList[i];
    for (let j = 0; j < v.n; j++) {
      const bac = clamp(v.bacTB + ladderBac[j % ladderBac.length], 1, 5);
      const tn = [0.5, 1.5, 2.7, 4.2, 6.0][bac - 1];
      let banHS = v.ban;
      if (v.id === 'chu') {
        banHS = I.chu === 'full' ? 1.00 : (I.chu === 'part' ? 0.50 : 0);
      }
      ns.push({
        stt: ++stt,
        viTri: v.ten,
        vtId: v.id,
        hsVT: v.hs,
        loai: v.loai,
        bac: bac,
        hsBac: SALARY_LIB.bacHS[bac - 1],
        thamNien: tn,
        cchn: v.cchn === 1,
        bang: v.bang,
        abil: v.abil,
        banHS: banHS,
        kpiDiem: I.kpi ? ladderKPI[(stt - 1) % ladderKPI.length] : 85,
      });
    }
  }
  R.ns = ns;
  R.soNguoi = ns.length;
  R.soBan = ns.filter((item) => item.banHS > 0).length;

  // 3. P1 Lương vị trí, P2 Phụ cấp năng lực
  let quyCung = 0;
  for (let k = 0; k < ns.length; k++) {
    const p = ns[k];
    const rut = I.mo === '3P' ? SALARY_LIB.heSo3P : 1;
    p.p1 = Math.max(LTTV, LTTV * p.hsVT * p.hsBac * (I.mct / 100) * rut);
    p.p1 = Math.round(p.p1 / 1000) * 1000;

    if (I.mo === '3P') {
      let pcc = 0;
      if (p.cchn) pcc += SALARY_LIB.phucCap.cchn;
      if (p.bang) pcc += SALARY_LIB.phucCap[p.bang] || 0;
      pcc += Math.min(SALARY_LIB.phucCap.tnMax, Math.floor(p.thamNien) * SALARY_LIB.phucCap.tnNam);
      p.p2 = pcc;
    } else {
      p.p2 = 0;
    }
    p.p2 = Math.round(((p.p2 * I.mct) / 100) / 1000) * 1000;
    p.hsKPI = I.kpi ? getKpiHs(p.kpiDiem) : 1;
    quyCung += p.p1 + p.p2;
  }
  R.quyCung = quyCung;

  // 4. Quỹ thưởng
  const quyThuong = R.thuongN[0] + R.thuongN[1] + R.thuongN[2];
  R.quyThuongGoc = quyThuong;

  let W_HT = 0;
  let W_BAN = 0;
  for (let q0 = 0; q0 < ns.length; q0++) {
    const e0 = ns[q0];
    if (e0.loai === 'ho') W_HT += e0.hsVT * e0.hsBac;
    else if (e0.banHS > 0) W_BAN += e0.hsVT * e0.hsBac * e0.banHS;
  }
  R.W_HT = W_HT;
  R.W_BAN = W_BAN;

  const kHT = I.ht / 100;
  R.tyTrongHT = W_BAN + W_HT * kHT > 0 ? (W_HT * kHT) / (W_BAN + W_HT * kHT) : 0;
  R.tuiHT = quyThuong * R.tyTrongHT;
  R.tuiBan = quyThuong - R.tuiHT;

  // Phân bổ doanh số giả lập cho từng người bán hàng
  for (let g = 0; g < 3; g++) {
    let tongTrong = 0;
    for (let s = 0; s < ns.length; s++) {
      const q = ns[s];
      q._w = q.banHS > 0 ? q.banHS * q.abil[g] * (0.75 + 0.25 * q.hsBac) : 0;
      tongTrong += q._w;
    }
    for (let s2 = 0; s2 < ns.length; s2++) {
      const q2 = ns[s2];
      if (!q2.dtCN) {
        q2.dtCN = [0, 0, 0];
        q2.lgCN = [0, 0, 0];
      }
      q2.dtCN[g] = tongTrong > 0 ? (R.dtN[g] * q2._w) / tongTrong : 0;
      q2.lgCN[g] = (q2.dtCN[g] * I.m[g]) / 100;
    }
  }

  // Chia thưởng
  let sumHT = 0;
  let sumBanHS = 0;
  for (let t = 0; t < ns.length; t++) {
    const u = ns[t];
    if (u.loai === 'ho') sumHT += u.hsVT * u.hsBac * u.hsKPI;
    if (u.banHS > 0) sumBanHS += u.hsVT * u.hsBac * u.hsKPI * u.banHS;
  }

  let tongThuong = 0;
  for (let t2 = 0; t2 < ns.length; t2++) {
    const z = ns[t2];
    z.dtCaNhan = z.dtCN[0] + z.dtCN[1] + z.dtCN[2];
    z.lgCaNhan = z.lgCN[0] + z.lgCN[1] + z.lgCN[2];

    if (z.loai === 'ho') {
      z.p3 = sumHT > 0 ? (R.tuiHT * (z.hsVT * z.hsBac * z.hsKPI)) / sumHT : 0;
      z.cachTinh = 'Chia từ túi hỗ trợ theo hệ số vị trí × bậc × KPI';
    } else if (I.cn) {
      let b = 0;
      for (let g2 = 0; g2 < 3; g2++) {
        b += (z.lgCN[g2] * I.rate[g2]) / 100;
      }
      z.p3 = b * (1 - R.tyTrongHT) * z.hsKPI;
      z.cachTinh = 'Trích thẳng trên lãi gộp cá nhân bán được × hệ số KPI';
    } else {
      z.p3 = sumBanHS > 0 ? (R.tuiBan * (z.hsVT * z.hsBac * z.hsKPI * z.banHS)) / sumBanHS : 0;
      z.cachTinh = 'Chia từ túi bán hàng theo hệ số vị trí × bậc × KPI';
    }

    z.p3 = Math.round(z.p3 / 1000) * 1000;
    z.tong = z.p1 + z.p2 + z.p3;
    z.tyTrongThuong = z.tong > 0 ? (z.p3 / z.tong) * 100 : 0;
    tongThuong += z.p3;
  }
  R.quyThuong = tongThuong;
  R.quyTong = R.quyCung + R.quyThuong;

  // 5. Chỉ số tài chính & sức khỏe quỹ lương
  R.tlDT = I.dt > 0 ? (R.quyTong / I.dt) * 100 : 0;
  R.tlLG = R.lg > 0 ? (R.quyTong / R.lg) * 100 : 0;
  R.dtNguoi = R.soNguoi > 0 ? I.dt / R.soNguoi : 0;
  R.lgNguoi = R.soNguoi > 0 ? R.lg / R.soNguoi : 0;
  R.tnBQ = R.soNguoi > 0 ? R.quyTong / R.soNguoi : 0;
  R.tlThuong = R.quyTong > 0 ? (R.quyThuong / R.quyTong) * 100 : 0;
  R.loiNhuan = R.lg - R.quyTong - I.chiPhi;
  R.hoaVon = R.bien > 0 ? (R.quyCung + I.chiPhi) / (R.bien / 100) : 0;
  R.hoaVonDu = R.bien > 0 ? (R.quyTong + I.chiPhi) / (R.bien / 100) : 0;

  // Kịch bản cả đội đạt KPI xuất sắc (đo trần rủi ro)
  const heSoMax = I.kpi ? 1.30 : 1.00;
  let heSoBQ = 0;
  let dem = 0;
  for (let q3 = 0; q3 < ns.length; q3++) {
    heSoBQ += ns[q3].hsKPI;
    dem++;
  }
  heSoBQ = dem > 0 ? heSoBQ / dem : 1;
  R.hsKPIbq = heSoBQ;
  R.quyTranKPI = I.cn ? R.quyCung + R.quyThuong * (heSoMax / Math.max(0.01, heSoBQ)) : R.quyTong;
  R.tlLGTran = R.lg > 0 ? (R.quyTranKPI / R.lg) * 100 : 0;

  // Đội hình chuẩn
  const gioThang = I.gio * I.ngay;
  R.nguoiPhuCa = Math.max(1, Math.ceil(gioThang / 208));
  R.nguoiTheoDT = Math.max(1, Math.round(I.dt / 1e6 / 130));
  R.doiHinhChuan = clamp(Math.max(R.nguoiPhuCa, R.nguoiTheoDT), 1, 12);
  R.gioThang = gioThang;

  // Mức chi trả vừa túi quầy
  const mucTieuLG = (SALARY_LIB.nguong.lgTot / 100) * R.lg;
  let cungAt100 = 0;
  for (let w = 0; w < ns.length; w++) {
    const y = ns[w];
    const p1_100 = Math.max(LTTV, LTTV * y.hsVT * y.hsBac * (I.mo === '3P' ? SALARY_LIB.heSo3P : 1));
    cungAt100 += p1_100 + y.p2;
  }
  R.mucVua = cungAt100 > 0 ? clamp(Math.round(((mucTieuLG - R.quyThuong) / cungAt100) * 100), 55, 130) : 100;
  R.chiPhiMoiNguoi = R.soNguoi > 0 ? R.quyTong / R.soNguoi : 0;
  R.nguoiToiDa = R.chiPhiMoiNguoi > 0 ? Math.max(1, Math.floor(mucTieuLG / R.chiPhiMoiNguoi)) : 0;
  R.dtCan = R.quyTong / (SALARY_LIB.nguong.dtTot / 100);

  // Đèn tín hiệu
  function den(v, tot, xau, nghich) {
    if (nghich) {
      return v >= tot ? 'good' : (v >= xau ? 'warn' : 'bad');
    }
    return v <= tot ? 'good' : (v <= xau ? 'warn' : 'bad');
  }

  R.den = {
    dt: den(R.tlDT, SALARY_LIB.nguong.dtTot, SALARY_LIB.nguong.dtXau),
    lg: den(R.tlLG, SALARY_LIB.nguong.lgTot, SALARY_LIB.nguong.lgXau),
    dtNguoi: den(R.dtNguoi / 1e6, SALARY_LIB.nguong.dtNguoiTot, SALARY_LIB.nguong.dtNguoiXau, true),
    loiNhuan: R.loiNhuan > R.lg * 0.15 ? 'good' : (R.loiNhuan > 0 ? 'warn' : 'bad'),
  };

  let diem = 0;
  const ds = [R.den.dt, R.den.lg, R.den.dtNguoi, R.den.loiNhuan];
  for (let d = 0; d < ds.length; d++) {
    diem += ds[d] === 'good' ? 2 : (ds[d] === 'warn' ? 1 : 0);
  }
  R.mucRuiRo = diem >= 7 ? 'khoe' : (diem >= 4 ? 'canh_bao' : 'quy_luong_vuot');
  R.thieuDT = I.dt <= 0 || R.lg <= 0;
  if (R.thieuDT) R.mucRuiRo = 'canh_bao';

  // Cảnh báo & Khuyến nghị
  const C = [];
  let duoiSan = 0;
  for (let e = 0; e < ns.length; e++) {
    if (ns[e].p1 < LTTV) duoiSan++;
  }
  if (duoiSan > 0) {
    C.push({
      t: 'bad',
      h: 'Có mức lương dưới sàn tối thiểu vùng',
      p: `Lương vị trí phải luôn từ ${fmtMoney(LTTV)} trở lên với ${SALARY_LIB.vungTen[I.vung]}. Hệ thống đã tự kẹp lên sàn, nhưng bạn nên xem lại mức chi trả đang đặt.`,
    });
  }

  let coDS = 0;
  let coChu = 0;
  for (let f = 0; f < vtList.length; f++) {
    if (vtList[f].id === 'dsptcm') coDS = vtList[f].n;
    if (vtList[f].id === 'chu') coChu = vtList[f].n;
  }

  if (coDS < 1 && coChu >= 1) {
    C.push({
      t: 'warn',
      h: 'Chủ đang kiêm luôn phụ trách chuyên môn',
      p: 'Chỉ hợp lệ nếu chủ có chứng chỉ hành nghề dược và có mặt trong toàn bộ thời gian quầy mở cửa. Nếu không, phải bố trí người đủ điều kiện đứng tên phụ trách chuyên môn.',
    });
  } else if (coDS < 1) {
    C.push({
      t: 'bad',
      h: 'Chưa có dược sĩ phụ trách chuyên môn',
      p: 'Quầy thuốc bắt buộc phải có người phụ trách chuyên môn có chứng chỉ hành nghề và có mặt trong toàn bộ thời gian quầy hoạt động theo quy định GPP.',
    });
  }

  if (R.thieuDT) {
    C.push({
      t: 'bad',
      h: 'Chưa có doanh thu hoặc lãi gộp để tính',
      p: 'Nhập doanh thu tháng ở bước 1 và biên lãi gộp từng nhóm ở bước 2 để công cụ sinh ra quỹ thưởng và tính toán kiểm tra.',
    });
  }

  if (R.soNguoi === 0) {
    C.push({
      t: 'bad',
      h: 'Chưa nhập người nào vào bảng lương',
      p: 'Nhập ít nhất một vị trí có người ở bước 3 để công cụ dựng được bảng lương.',
    });
  }

  if (R.soNguoi > 0 && R.soNguoi < R.nguoiPhuCa) {
    C.push({
      t: 'warn',
      h: 'Đội hình mỏng hơn số giờ mở cửa',
      p: `Mở ${I.gio} giờ/ngày, ${I.ngay} ngày/tháng là ${r0(R.gioThang)} giờ. Một nhân sự chuẩn làm tối đa 208 giờ/tháng, cần tối thiểu ${R.nguoiPhuCa} người. Hiện có ${R.soNguoi} người, phần chênh sẽ tính làm thêm giờ (tối thiểu 150%).`,
    });
  }

  if (R.tlDT > SALARY_LIB.nguong.dtXau) {
    C.push({
      t: 'bad',
      h: 'Quỹ lương ăn quá sâu vào doanh thu',
      p: `Quỹ lương đang chiếm ${fmtPercent(R.tlDT)} doanh thu (ngưỡng an toàn ngành là dưới ${SALARY_LIB.nguong.dtTot}%). Cần giảm mức chi trả, tinh gọn nhân sự hoặc kéo doanh thu lên ${fmtTrieu(R.quyTong / (SALARY_LIB.nguong.dtTot / 100), 0)}/tháng.`,
    });
  } else if (R.tlDT > SALARY_LIB.nguong.dtTot) {
    C.push({
      t: 'warn',
      h: 'Quỹ lương hơi cao so với doanh thu',
      p: `Đang ở mức ${fmtPercent(R.tlDT)} doanh thu. Vẫn gánh được nhưng biên độ an toàn dự phòng không còn nhiều khi doanh số suy giảm.`,
    });
  }

  if (R.tlLG > SALARY_LIB.nguong.lgXau) {
    C.push({
      t: 'bad',
      h: 'Quỹ lương ăn quá sâu vào lãi gộp',
      p: `Đang chiếm ${fmtPercent(R.tlLG)} lãi gộp. Từ 60% trở lên sẽ không còn đủ thặng dư để trả chi phí mặt bằng, điện nước, khấu hao và tái nhập hàng.`,
    });
  }

  if (R.bien > 0 && R.bien < 15) {
    C.push({
      t: 'warn',
      h: 'Biên lãi gộp toàn quầy quá mỏng',
      p: `Biên lãi gộp đang ở mức ${fmtPercent(R.bien)} (chuẩn quầy thuốc khoẻ là 20–26%). Cần đẩy mạnh tỷ trọng hàng tư vấn (Nhóm 2) và hàng chiến lược/TPCN (Nhóm 3).`,
    });
  }

  if (R.wn[0] > 0.70) {
    C.push({
      t: 'warn',
      h: 'Quầy đang sống phụ thuộc vào hàng thông dụng',
      p: `Nhóm 1 chiếm ${fmtPercent(R.wn[0] * 100, 0)} doanh thu nhưng chỉ tạo ra ${fmtPercent((R.lgN[0] / Math.max(1, R.lg)) * 100, 0)} lãi gộp. Nhân sự cần được đào tạo kỹ năng tư vấn để chuyển dịch cơ cấu.`,
    });
  }

  if (R.dtNguoi / 1e6 < SALARY_LIB.nguong.dtNguoiXau && R.soNguoi > 0) {
    C.push({
      t: 'warn',
      h: 'Năng suất bình quân mỗi người thấp',
      p: `Mỗi nhân sự đang gánh ${fmtTrieu(R.dtNguoi, 0)} doanh thu/tháng (mức lành mạnh là từ ${SALARY_LIB.nguong.dtNguoiTot} triệu). Cần tối ưu ca kíp hoặc gia tăng lượng khách.`,
    });
  }

  if (R.tlThuong < SALARY_LIB.nguong.thuongThap && R.soNguoi > 0) {
    C.push({
      t: 'warn',
      h: 'Phần thưởng quá nhỏ để tạo động lực tư vấn',
      p: `Thưởng chỉ chiếm ${fmtPercent(R.tlThuong)} tổng thu nhập. Dưới 12% thì nhân sự coi như lương cứng, cơ chế thưởng mất tác dụng. Hãy nâng tỷ lệ trích nhóm 2 và nhóm 3.`,
    });
  }

  if (R.tlThuong > SALARY_LIB.nguong.thuongCao) {
    C.push({
      t: 'warn',
      h: 'Thu nhập phụ thuộc quá nhiều vào thưởng',
      p: `Thưởng chiếm ${fmtPercent(R.tlThuong)} thu nhập. Trên 45% thì tháng thấp điểm nhân sự sẽ hụt tiền và dễ dao động nghỉ việc. Nên tăng nhẹ lương cứng và hạ bớt trích thưởng.`,
    });
  }

  if (I.mo === '2P' && R.soNguoi >= 4) {
    C.push({
      t: 'warn',
      h: 'Quầy từ 4 người dùng 2P sẽ khó giữ chân dược sĩ giỏi',
      p: 'Mô hình 2P không trả riêng cho bằng cấp và CCHN. Người có bằng đại học dược và người trung cấp cùng bậc sẽ nhận gần bằng nhau.',
    });
  }

  if (C.length === 0) {
    C.push({
      t: 'good',
      h: 'Cơ chế đang rất cân đối & an toàn',
      p: 'Quỹ lương nằm trong ngưỡng vàng cả trên doanh thu lẫn trên lãi gộp, năng suất nhân viên tốt, tỷ trọng thưởng tạo động lực mạnh mẽ mà không gây bấp bênh.',
    });
  }
  R.canhBao = C.slice(0, 7);

  return R;
}

/* ============================================================
   BỘ TẠO FILE EXCEL 7 SHEET CÔNG THỨC SỐNG (OpenXML Zip Engine)
   Chạy 100% Client-Side, Không phụ thuộc thư viện ngoài nặng nề
   ============================================================ */
const CRC_T = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1;
    t[n] = c >>> 0;
  }
  return t;
})();

function crc32(u8) {
  let c = 0xFFFFFFFF;
  for (let i = 0; i < u8.length; i++) c = CRC_T[(c ^ u8[i]) & 0xFF] ^ (c >>> 8);
  return (c ^ 0xFFFFFFFF) >>> 0;
}

function utf8(s) {
  return new TextEncoder().encode(s);
}

function zipBuild(files) {
  const parts = [];
  const central = [];
  let offset = 0;

  function u16(n) {
    return [n & 255, (n >>> 8) & 255];
  }
  function u32(n) {
    return [n & 255, (n >>> 8) & 255, (n >>> 16) & 255, (n >>> 24) & 255];
  }

  for (let i = 0; i < files.length; i++) {
    const f = files[i];
    const nameB = utf8(f.name);
    const data = f.data;
    const crc = crc32(data);
    const lh = [].concat(
      [0x50, 0x4b, 0x03, 0x04],
      u16(20),
      u16(0x0800),
      u16(0),
      u16(0),
      u16(0),
      u32(crc),
      u32(data.length),
      u32(data.length),
      u16(nameB.length),
      u16(0)
    );
    parts.push(new Uint8Array(lh), nameB, data);

    const ch = [].concat(
      [0x50, 0x4b, 0x01, 0x02],
      u16(20),
      u16(20),
      u16(0x0800),
      u16(0),
      u16(0),
      u16(0),
      u32(crc),
      u32(data.length),
      u32(data.length),
      u16(nameB.length),
      u16(0),
      u16(0),
      u16(0),
      u16(0),
      u32(0),
      u32(offset)
    );
    central.push(new Uint8Array(ch), nameB);
    offset += lh.length + nameB.length + data.length;
  }

  let cdSize = 0;
  for (let c2 = 0; c2 < central.length; c2++) cdSize += central[c2].length;
  const eocd = new Uint8Array(
    [].concat([0x50, 0x4b, 0x05, 0x06], u16(0), u16(0), u16(files.length), u16(files.length), u32(cdSize), u32(offset), u16(0))
  );

  const all = parts.concat(central, [eocd]);
  let total = 0;
  for (let a = 0; a < all.length; a++) total += all[a].length;
  const out = new Uint8Array(total);
  let p = 0;
  for (let b = 0; b < all.length; b++) {
    out.set(all[b], p);
    p += all[b].length;
  }
  return out;
}

const S = {
  def: 0,
  title: 1,
  h2: 2,
  note: 3,
  hdr: 4,
  lbl: 5,
  inNum: 6,
  inPct: 7,
  num: 8,
  pct: 9,
  money: 10,
  txt: 11,
  totNum: 12,
  totTxt: 13,
  dec2: 14,
  inDec2: 15,
  sub: 16,
  wrap: 17,
  good: 18,
  bad: 19,
  center: 20,
  inCenter: 21,
  dec1: 22,
  hdrL: 23,
  inTxt: 24,
  warn: 25,
};

const STYLES_XML = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
<numFmts count="6">
<numFmt numFmtId="164" formatCode="#,##0"/>
<numFmt numFmtId="165" formatCode="0.0%"/>
<numFmt numFmtId="166" formatCode="#,##0&quot; đ&quot;"/>
<numFmt numFmtId="167" formatCode="0.00"/>
<numFmt numFmtId="168" formatCode="#,##0.0"/>
<numFmt numFmtId="169" formatCode="0%"/>
</numFmts>
<fonts count="7">
<font><sz val="11"/><name val="Calibri"/></font>
<font><b/><sz val="11"/><name val="Calibri"/></font>
<font><b/><sz val="16"/><color rgb="FF0D7A6F"/><name val="Calibri"/></font>
<font><b/><sz val="11"/><color rgb="FFFFFFFF"/><name val="Calibri"/></font>
<font><i/><sz val="10"/><color rgb="FF6C817D"/><name val="Calibri"/></font>
<font><b/><sz val="12"/><color rgb="FF0D7A6F"/><name val="Calibri"/></font>
<font><sz val="10"/><color rgb="FF6C817D"/><name val="Calibri"/></font>
</fonts>
<fills count="8">
<fill><patternFill patternType="none"/></fill>
<fill><patternFill patternType="gray125"/></fill>
<fill><patternFill patternType="solid"><fgColor rgb="FF0D7A6F"/><bgColor indexed="64"/></patternFill></fill>
<fill><patternFill patternType="solid"><fgColor rgb="FFFFF3C4"/><bgColor indexed="64"/></patternFill></fill>
<fill><patternFill patternType="solid"><fgColor rgb="FFE9F0EE"/><bgColor indexed="64"/></patternFill></fill>
<fill><patternFill patternType="solid"><fgColor rgb="FFD6EAE6"/><bgColor indexed="64"/></patternFill></fill>
<fill><patternFill patternType="solid"><fgColor rgb="FFDFF1E7"/><bgColor indexed="64"/></patternFill></fill>
<fill><patternFill patternType="solid"><fgColor rgb="FFFADFDA"/><bgColor indexed="64"/></patternFill></fill>
</fills>
<borders count="2">
<border><left/><right/><top/><bottom/><diagonal/></border>
<border><left style="thin"><color rgb="FFD3DFDC"/></left><right style="thin"><color rgb="FFD3DFDC"/></right><top style="thin"><color rgb="FFD3DFDC"/></top><bottom style="thin"><color rgb="FFD3DFDC"/></bottom><diagonal/></border>
</borders>
<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>
<cellXfs count="26">
<xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>
<xf numFmtId="0" fontId="2" fillId="0" borderId="0" xfId="0" applyFont="1"/>
<xf numFmtId="0" fontId="5" fillId="0" borderId="0" xfId="0" applyFont="1"/>
<xf numFmtId="0" fontId="4" fillId="0" borderId="0" xfId="0" applyFont="1" applyAlignment="1"><alignment vertical="top" wrapText="1"/></xf>
<xf numFmtId="0" fontId="3" fillId="2" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment horizontal="center" vertical="center" wrapText="1"/></xf>
<xf numFmtId="0" fontId="1" fillId="0" borderId="0" xfId="0" applyFont="1"/>
<xf numFmtId="164" fontId="0" fillId="3" borderId="1" xfId="0" applyNumberFormat="1" applyFill="1" applyBorder="1"/>
<xf numFmtId="165" fontId="0" fillId="3" borderId="1" xfId="0" applyNumberFormat="1" applyFill="1" applyBorder="1"/>
<xf numFmtId="164" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1"/>
<xf numFmtId="165" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1"/>
<xf numFmtId="166" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1"/>
<xf numFmtId="0" fontId="0" fillId="0" borderId="1" xfId="0" applyBorder="1" applyAlignment="1"><alignment vertical="center"/></xf>
<xf numFmtId="164" fontId="1" fillId="4" borderId="1" xfId="0" applyNumberFormat="1" applyFont="1" applyFill="1" applyBorder="1"/>
<xf numFmtId="0" fontId="1" fillId="4" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1"/>
<xf numFmtId="167" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1"/>
<xf numFmtId="167" fontId="0" fillId="3" borderId="1" xfId="0" applyNumberFormat="1" applyFill="1" applyBorder="1"/>
<xf numFmtId="0" fontId="1" fillId="5" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1"/>
<xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" applyAlignment="1"><alignment vertical="top" wrapText="1"/></xf>
<xf numFmtId="0" fontId="1" fillId="6" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment wrapText="1" vertical="center"/></xf>
<xf numFmtId="0" fontId="1" fillId="7" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment wrapText="1" vertical="center"/></xf>
<xf numFmtId="0" fontId="0" fillId="0" borderId="1" xfId="0" applyBorder="1" applyAlignment="1"><alignment horizontal="center" vertical="center"/></xf>
<xf numFmtId="0" fontId="0" fillId="3" borderId="1" xfId="0" applyFill="1" applyBorder="1" applyAlignment="1"><alignment horizontal="center" vertical="center"/></xf>
<xf numFmtId="168" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1"/>
<xf numFmtId="0" fontId="3" fillId="2" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment horizontal="left" vertical="center" wrapText="1"/></xf>
<xf numFmtId="0" fontId="0" fillId="3" borderId="1" xfId="0" applyFill="1" applyBorder="1"/>
<xf numFmtId="0" fontId="1" fillId="3" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment wrapText="1" vertical="center"/></xf>
</cellXfs>
<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>
</styleSheet>`;

function colL(n) {
  let s = '';
  n = n + 1;
  while (n > 0) {
    const m = (n - 1) % 26;
    s = String.fromCharCode(65 + m) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
}

function xesc(s) {
  return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

class WS {
  constructor(name) {
    this.name = name;
    this.rows = [];
    this.merges = [];
    this.cols = null;
  }
  add(cells) {
    this.rows.push(cells || []);
    return this.rows.length;
  }
  at() {
    return this.rows.length;
  }
  merge(r1, c1, r2, c2) {
    this.merges.push(`${colL(c1)}${r1}:${colL(c2)}${r2}`);
  }
  xml() {
    let x = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
<sheetPr><outlinePr summaryBelow="1" summaryRight="1"/></sheetPr>`;
    if (this.cols) {
      x += '<cols>';
      for (let c = 0; c < this.cols.length; c++) {
        x += `<col min="${c + 1}" max="${c + 1}" width="${this.cols[c]}" customWidth="1"/>`;
      }
      x += '</cols>';
    }
    x += '<sheetData>';
    for (let r = 0; r < this.rows.length; r++) {
      const row = this.rows[r];
      const rn = r + 1;
      let cellsXml = '';
      let has = false;
      for (let i = 0; i < row.length; i++) {
        const cell = row[i];
        if (cell === null || cell === undefined) continue;
        has = true;
        const ref = colL(i) + rn;
        const st = cell.s !== undefined ? ` s="${cell.s}"` : '';
        if (cell.f !== undefined) {
          cellsXml += `<c r="${ref}"${st}><f>${xesc(cell.f)}</f></c>`;
        } else if (typeof cell.v === 'number') {
          cellsXml += `<c r="${ref}"${st}><v>${cell.v}</v></c>`;
        } else if (cell.v === null || cell.v === undefined || cell.v === '') {
          cellsXml += `<c r="${ref}"${st}/>`;
        } else {
          cellsXml += `<c r="${ref}"${st} t="inlineStr"><is><t xml:space="preserve">${xesc(cell.v)}</t></is></c>`;
        }
      }
      if (has) x += `<row r="${rn}">${cellsXml}</row>`;
    }
    x += '</sheetData>';
    if (this.merges.length) {
      x += `<mergeCells count="${this.merges.length}">`;
      for (let m = 0; m < this.merges.length; m++) {
        x += `<mergeCell ref="${this.merges[m]}"/>`;
      }
      x += '</mergeCells>';
    }
    x += '<pageMargins left="0.5" right="0.5" top="0.6" bottom="0.6" header="0.3" footer="0.3"/></worksheet>';
    return x;
  }
}

function xlsxBuild(sheets) {
  const files = [];
  let ct = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>
<Default Extension="xml" ContentType="application/xml"/>
<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>
<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>`;
  for (let i = 0; i < sheets.length; i++) {
    ct += `<Override PartName="/xl/worksheets/sheet${i + 1}.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>`;
  }
  ct += '</Types>';
  files.push({ name: '[Content_Types].xml', data: utf8(ct) });
  files.push({
    name: '_rels/.rels',
    data: utf8(
      '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>'
    ),
  });

  let wb =
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><sheets>';
  for (let s = 0; s < sheets.length; s++) {
    wb += `<sheet name="${xesc(sheets[s].name)}" sheetId="${s + 1}" r:id="rId${s + 1}"/>`;
  }
  wb += '</sheets><calcPr calcId="0" fullCalcOnLoad="1"/></workbook>';
  files.push({ name: 'xl/workbook.xml', data: utf8(wb) });

  let rels =
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">';
  for (let s2 = 0; s2 < sheets.length; s2++) {
    rels += `<Relationship Id="rId${s2 + 1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet${s2 + 1}.xml"/>`;
  }
  rels += `<Relationship Id="rId${sheets.length + 1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/></Relationships>`;
  files.push({ name: 'xl/_rels/workbook.xml.rels', data: utf8(rels) });
  files.push({ name: 'xl/styles.xml', data: utf8(STYLES_XML) });
  for (let s3 = 0; s3 < sheets.length; s3++) {
    files.push({ name: `xl/worksheets/sheet${s3 + 1}.xml`, data: utf8(sheets[s3].xml()) });
  }

  return new Blob([zipBuild(files)], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
}

const N1 = '1.THAM SO';
const N2 = '2.THANG LUONG';
const N3 = '3.PHU CAP-KPI';
const N4 = '4.BANG LUONG';
const N5 = '5.SUC KHOE';
const N6 = '6.QUY CHE';
const N7 = '7.THE DIEM KPI';
const Q1 = `'${N1}'!`;
const Q2 = `'${N2}'!`;
const Q3 = `'${N3}'!`;
const Q4 = `'${N4}'!`;

function C(v, s) {
  return { v: v, s: s === undefined ? S.def : s };
}
function F(f, s) {
  return { f: f, s: s === undefined ? S.num : s };
}

export function exportSalaryExcel(R, fileName = 'co-che-luong-thuong-quay-thuoc.xlsx') {
  if (!R || !R.ns || R.ns.length === 0) {
    throw new Error('Cần nhập ít nhất một vị trí có người trước khi tải file.');
  }

  const I = R.I;
  const sh = [];
  const LAST = 3 + Math.max(1, R.ns.length);
  const B = `'${N4}'!`;
  const wHT = `SUMPRODUCT((${B}$C$4:$C$${LAST}="Hỗ trợ")*${B}$D$4:$D$${LAST}*${B}$F$4:$F$${LAST})`;
  const wBAN = `SUMPRODUCT((${B}$C$4:$C$${LAST}<>"Hỗ trợ")*${B}$D$4:$D$${LAST}*${B}$F$4:$F$${LAST}*${B}$J$4:$J$${LAST})`;
  const ngay = new Date();
  const stamp = `${ngay.getDate()}/${ngay.getMonth() + 1}/${ngay.getFullYear()}`;

  /* ---------------- SHEET 1 · THAM SỐ ---------------- */
  const s1 = new WS(N1);
  s1.cols = [46, 18, 13, 17, 17, 12, 17];
  s1.add([C('CƠ CHẾ LƯƠNG THƯỞNG QUẦY THUỐC', S.title)]);
  s1.merge(1, 0, 1, 6);
  s1.add([
    C(
      `Ô nền vàng là ô bạn sửa được. Sửa xong, toàn bộ các sheet sau tự tính lại. Tạo ngày ${stamp} · Thế Thảo Pharma · Nhà Thuốc & Dược Sĩ 5.0`,
      S.note
    ),
  ]);
  s1.merge(2, 0, 2, 6);
  s1.add([]);
  s1.add([C('A. BỐI CẢNH QUẦY', S.h2)]);
  s1.add([C('Doanh thu trung bình mỗi tháng', S.lbl), C(r0(I.dt), S.inNum), C('đồng', S.note)]);
  s1.add([C('Số ngày mở cửa mỗi tháng', S.lbl), C(I.ngay, S.inNum), C('ngày', S.note)]);
  s1.add([C('Số giờ mở cửa mỗi ngày', S.lbl), C(I.gio, S.inDec2), C('giờ', S.note)]);
  s1.add([
    C('Vùng lương tối thiểu (nhập 1, 2, 3 hoặc 4)', S.lbl),
    C(parseInt(I.vung, 10), S.inNum),
    C(SALARY_LIB.vungTen[I.vung], S.note),
  ]);
  s1.add([
    C('Mức lương tối thiểu vùng đang áp dụng', S.lbl),
    F('CHOOSE($B$8,5310000,4730000,4140000,3700000)', S.num),
    C('Nghị định 293/2025/NĐ-CP', S.note),
  ]);
  s1.add([
    C('Mức chi trả so với chuẩn tham chiếu', S.lbl),
    C(I.mct / 100, S.inPct),
    C('kéo xuống nếu mặt bằng lương địa phương thấp', S.note),
  ]);
  s1.add([
    C('Chi phí cố định khác mỗi tháng', S.lbl),
    C(r0(I.chiPhi), S.inNum),
    C('mặt bằng, điện nước, phần mềm', S.note),
  ]);
  s1.add([]);
  s1.add([C('B. CƠ CẤU NHÓM HÀNG VÀ LÃI GỘP', S.h2)]);
  s1.add([
    C('Nhóm hàng', S.hdrL),
    C('Tỷ trọng doanh thu', S.hdr),
    C('Biên lãi gộp', S.hdr),
    C('Doanh thu nhóm', S.hdr),
    C('Lãi gộp nhóm', S.hdr),
    C('Tỷ lệ trích thưởng', S.hdr),
    C('Quỹ thưởng sinh ra', S.hdr),
  ]);
  const tenN = [
    'Nhóm 1 · Hàng thông dụng, khách hỏi đúng tên',
    'Nhóm 2 · Hàng tư vấn, phải hỏi bệnh mới bán được',
    'Nhóm 3 · Hàng chiến lược, TPCN, mỹ phẩm, độc quyền',
  ];
  for (let g = 0; g < 3; g++) {
    const rw = 15 + g;
    s1.add([
      C(tenN[g], S.txt),
      C(I.w[g] / 100, S.inPct),
      C(I.m[g] / 100, S.inPct),
      F(`$B$5*B${rw}/$B$18`, S.num),
      F(`D${rw}*C${rw}`, S.num),
      C(I.rate[g] / 100, S.inPct),
      F(`E${rw}*F${rw}`, S.num),
    ]);
  }
  s1.add([
    C('TỔNG', S.totTxt),
    F('SUM(B15:B17)', S.pct),
    F('IF(D18=0,0,E18/D18)', S.pct),
    F('SUM(D15:D17)', S.totNum),
    F('SUM(E15:E17)', S.totNum),
    C('', S.totTxt),
    F('SUM(G15:G17)', S.totNum),
  ]);
  s1.add([]);
  s1.add([C('C. CHÍNH SÁCH CHIA THƯỞNG', S.h2)]);
  s1.add([
    C('Mức hưởng của tuyến sau so với tuyến bán hàng', S.lbl),
    C(I.ht / 100, S.inPct),
    C('kho vận và kế toán không bán hàng nhưng giữ lãi gộp', S.note),
  ]);
  s1.add([
    C('Tỷ trọng quỹ thưởng của tuyến sau', S.lbl),
    F(`IFERROR(${wHT}*$B$21/(${wBAN}+${wHT}*$B$21),0)`, S.pct),
    C('tự co giãn theo số người và bậc, không ấn định cứng', S.note),
  ]);
  s1.add([C('Túi hỗ trợ (kho vận, kế toán)', S.lbl), F('$G$18*$B$22', S.num)]);
  s1.add([C('Túi bán hàng', S.lbl), F('$G$18-$B$23', S.num)]);
  s1.add([C('Mô hình lương — gõ 2P hoặc 3P', S.lbl), C(I.mo, S.inTxt)]);
  s1.add([C('Có gắn KPI vào thưởng — gõ Có hoặc Không', S.lbl), C(I.kpi ? 'Có' : 'Không', S.inTxt)]);
  s1.add([C('Tách được doanh số từng người — gõ Có hoặc Không', S.lbl), C(I.cn ? 'Có' : 'Không', S.inTxt)]);
  s1.add([
    C('Hệ số rút lương vị trí khi dùng 3P', S.lbl),
    C(SALARY_LIB.heSo3P, S.inDec2),
    C('để dành chỗ cho phụ cấp năng lực, tổng quỹ không phình', S.note),
  ]);
  s1.add([]);
  s1.add([
    C(
      'Bốn ô công tắc ở trên: Đổi 3P thành 2P là toàn bộ phụ cấp năng lực về 0. Đổi Có thành Không ở dòng tách doanh số thì cách chia thưởng đổi từ tính thẳng trên doanh thu từng người sang chia theo hệ số vị trí và bậc. Dòng Tỷ trọng quỹ thưởng của tuyến sau là ô công thức, không gõ đè.',
      S.note
    ),
  ]);
  s1.merge(30, 0, 30, 6);
  sh.push(s1);

  /* ---------------- SHEET 2 · THANG LƯƠNG ---------------- */
  const s2 = new WS(N2);
  s2.cols = [40, 13, 14, 14, 14, 14, 14];
  s2.add([C('THANG LƯƠNG VỊ TRÍ · 5 BẬC', S.title)]);
  s2.merge(1, 0, 1, 6);
  s2.add([
    C(
      'Lương vị trí = lương tối thiểu vùng × hệ số vị trí × hệ số bậc × mức chi trả × hệ số rút 3P, làm tròn nghìn và luôn kẹp trên sàn tối thiểu vùng.',
      S.note
    ),
  ]);
  s2.merge(2, 0, 2, 6);
  s2.add([
    C('Vị trí', S.hdrL),
    C('Hệ số vị trí', S.hdr),
    C('Bậc 1', S.hdr),
    C('Bậc 2', S.hdr),
    C('Bậc 3', S.hdr),
    C('Bậc 4', S.hdr),
    C('Bậc 5', S.hdr),
  ]);
  const r4 = [C('Hệ số bậc', S.sub), C('', S.sub)];
  for (let b = 0; b < 5; b++) r4.push(C(SALARY_LIB.bacHS[b], S.inDec2));
  s2.add(r4);

  for (let v = 0; v < SALARY_LIB.viTri.length; v++) {
    const rw2 = 5 + v;
    const row = [C(SALARY_LIB.viTri[v].ten, S.txt), C(SALARY_LIB.viTri[v].hs, S.inDec2)];
    for (let b2 = 0; b2 < 5; b2++) {
      const cl = colL(2 + b2);
      row.push(
        F(
          `ROUND(MAX(${Q1}$B$9,${Q1}$B$9*$B${rw2}*${cl}$4*${Q1}$B$10*IF(${Q1}$B$25="3P",${Q1}$B$28,1))/1000,0)*1000`,
          S.num
        )
      );
    }
    s2.add(row);
  }
  s2.add([]);
  s2.add([C('ĐIỀU KIỆN LÊN BẬC — KHÔNG CHỈ TÍNH THÂM NIÊN', S.h2)]);
  for (let d = 0; d < 5; d++) {
    const rr = s2.add([C(`Bậc ${d + 1}`, S.sub), C(SALARY_LIB.bacDK[d], S.wrap)]);
    s2.merge(rr, 1, rr, 6);
  }
  const rz = s2.add([
    C(
      'Khoảng cách giữa hai bậc liền kề là 9%. Đủ để người bậc dưới thấy đáng phấn đấu mà không làm vỡ quỹ lương khi cả đội cùng lên bậc.',
      S.note
    ),
  ]);
  s2.merge(rz, 0, rz, 6);
  sh.push(s2);

  /* ---------------- SHEET 3 · PHỤ CẤP & KPI ---------------- */
  const s3 = new WS(N3);
  s3.cols = [12, 42, 16, 28];
  s3.add([C('PHỤ CẤP NĂNG LỰC VÀ BẢNG QUY ĐỔI KPI', S.title)]);
  s3.merge(1, 0, 1, 3);
  s3.add([]);
  s3.add([C('A. PHỤ CẤP NĂNG LỰC — chỉ áp dụng ở mô hình 3P', S.h2)]);
  s3.merge(3, 0, 3, 3);
  s3.add([C('Mã', S.hdr), C('Khoản phụ cấp', S.hdrL), C('Mức (đồng)', S.hdr), C('Ghi chú', S.hdrL)]);
  s3.add([
    C('cchn', S.center),
    C('Chứng chỉ hành nghề dược', S.txt),
    C(SALARY_LIB.phucCap.cchn, S.inNum),
    C('Tách riêng, đừng gộp vào lương', S.txt),
  ]);
  s3.add([
    C('dh', S.center),
    C('Bằng đại học dược', S.txt),
    C(SALARY_LIB.phucCap.dh, S.inNum),
    C('Mỗi người chỉ hưởng một bằng cao nhất', S.txt),
  ]);
  s3.add([C('cd', S.center), C('Bằng cao đẳng dược', S.txt), C(SALARY_LIB.phucCap.cd, S.inNum), C('', S.txt)]);
  s3.add([C('tc', S.center), C('Bằng trung cấp dược', S.txt), C(SALARY_LIB.phucCap.tc, S.inNum), C('', S.txt)]);
  s3.add([
    C('tn', S.center),
    C('Thâm niên mỗi năm làm việc', S.txt),
    C(SALARY_LIB.phucCap.tnNam, S.inNum),
    C('Tính theo số năm tròn', S.txt),
  ]);
  s3.add([
    C('tnmax', S.center),
    C('Trần phụ cấp thâm niên', S.txt),
    C(SALARY_LIB.phucCap.tnMax, S.inNum),
    C('Chạm trần thì dừng', S.txt),
  ]);
  s3.add([]);
  s3.add([C('B. QUY ĐỔI ĐIỂM KPI RA HỆ SỐ NHÂN VÀO THƯỞNG', S.h2)]);
  s3.merge(12, 0, 12, 3);
  s3.add([C('Điểm từ', S.hdr), C('Hệ số', S.hdr), C('Xếp loại', S.hdrL), C('', S.hdrL)]);
  const thang = [
    [0, 0, 'Không đạt, không xét thưởng tháng đó'],
    [60, 0.65, 'Yếu, nhắc nhở bằng văn bản'],
    [70, 0.85, 'Cần cải thiện'],
    [80, 1.00, 'Đạt'],
    [90, 1.15, 'Tốt'],
    [95, 1.30, 'Xuất sắc'],
  ];
  for (let t = 0; t < thang.length; t++) {
    s3.add([C(thang[t][0], S.inNum), C(thang[t][1], S.inDec2), C(thang[t][2], S.txt), C('', S.txt)]);
  }
  s3.add([]);
  const rn = s3.add([
    C(
      'Bảng này để ở dạng tăng dần vì sheet Bảng lương dùng hàm LOOKUP để dò. Muốn nới hay siết thưởng thì sửa cột Hệ số, đừng xoá dòng.',
      S.note
    ),
  ]);
  s3.merge(rn, 0, rn, 3);
  sh.push(s3);

  /* ---------------- SHEET 4 · BẢNG LƯƠNG ---------------- */
  const s4 = new WS(N4);
  s4.cols = [5, 32, 11, 9, 7, 9, 7, 10, 9, 9, 8, 8, 14, 14, 14, 14, 14, 14, 15, 9];
  s4.add([C('BẢNG LƯƠNG GIẢ LẬP TỪNG NGƯỜI', S.title)]);
  s4.merge(1, 0, 1, 10);
  s4.add([
    C(
      'Cột nền vàng là ô nhập. Ba cột Doanh thu N1, N2, N3 lấy thẳng từ phần mềm bán hàng. Phần lãi gộp và tiền thưởng tự tính theo biên lãi gộp khai ở sheet Tham số.',
      S.note
    ),
  ]);
  s4.merge(2, 0, 2, 12);
  s4.add([
    C('STT', S.hdr),
    C('Vị trí', S.hdrL),
    C('Tuyến', S.hdr),
    C('Hệ số vị trí', S.hdr),
    C('Bậc', S.hdr),
    C('Hệ số bậc', S.hdr),
    C('CCHN', S.hdr),
    C('Bằng cấp', S.hdr),
    C('Thâm niên', S.hdr),
    C('Tham gia bán', S.hdr),
    C('Điểm KPI', S.hdr),
    C('Hệ số KPI', S.hdr),
    C('Doanh thu N1', S.hdr),
    C('Doanh thu N2', S.hdr),
    C('Doanh thu N3', S.hdr),
    C('P1 vị trí', S.hdr),
    C('P2 năng lực', S.hdr),
    C('P3 hiệu quả', S.hdr),
    C('TỔNG THU NHẬP', S.hdr),
    C('% thưởng', S.hdr),
  ]);

  const r0i = 4;
  const last = 3 + Math.max(1, R.ns.length);
  for (let n = 0; n < R.ns.length; n++) {
    const p = R.ns[n];
    const rw3 = r0i + n;
    const denomHT = `SUMPRODUCT(($C$${r0i}:$C$${last}="Hỗ trợ")*$D$${r0i}:$D$${last}*$F$${r0i}:$F$${last}*$L$${r0i}:$L$${last})`;
    const denomBan = `SUMPRODUCT(($C$${r0i}:$C$${last}<>"Hỗ trợ")*$D$${r0i}:$D$${last}*$F$${r0i}:$F$${last}*$L$${r0i}:$L$${last}*$J$${r0i}:$J$${last})`;
    const fP3 = `ROUND(IF($C${rw3}="Hỗ trợ",IFERROR(${Q1}$B$23*($D${rw3}*$F${rw3}*$L${rw3})/${denomHT},0),IF(${Q1}$B$27="Có",($M${rw3}*${Q1}$C$15*${Q1}$F$15+$N${rw3}*${Q1}$C$16*${Q1}$F$16+$O${rw3}*${Q1}$C$17*${Q1}$F$17)*(1-${Q1}$B$22)*$L${rw3},IFERROR(${Q1}$B$24*($D${rw3}*$F${rw3}*$L${rw3}*$J${rw3})/${denomBan},0)))/1000,0)*1000`;

    s4.add([
      C(p.stt, S.center),
      C(p.viTri, S.txt),
      C(p.loai === 'ho' ? 'Hỗ trợ' : 'Bán hàng', S.center),
      F(`IFERROR(VLOOKUP($B${rw3},${Q2}$A$5:$B$10,2,FALSE),0)`, S.dec2),
      C(p.bac, S.inCenter),
      F(`INDEX(${Q2}$C$4:$G$4,$E${rw3})`, S.dec2),
      C(p.cchn ? 1 : 0, S.inCenter),
      C(p.bang, S.inCenter),
      C(p.thamNien, S.inDec2),
      C(p.banHS, S.inDec2),
      C(p.kpiDiem, S.inCenter),
      F(`IF(${Q1}$B$26="Có",LOOKUP($K${rw3},${Q3}$A$14:$A$19,${Q3}$B$14:$B$19),1)`, S.dec2),
      C(r0(p.dtCN[0]), S.inNum),
      C(r0(p.dtCN[1]), S.inNum),
      C(r0(p.dtCN[2]), S.inNum),
      F(
        `ROUND(MAX(${Q1}$B$9,${Q1}$B$9*$D${rw3}*$F${rw3}*${Q1}$B$10*IF(${Q1}$B$25="3P",${Q1}$B$28,1))/1000,0)*1000`,
        S.num
      ),
      F(
        `ROUND(IF(${Q1}$B$25="3P",($G${rw3}*${Q3}$C$5+IFERROR(VLOOKUP($H${rw3},${Q3}$A$6:$C$8,3,FALSE),0)+MIN(${Q3}$C$10,INT($I${rw3})*${Q3}$C$9))*${Q1}$B$10,0)/1000,0)*1000`,
        S.num
      ),
      F(fP3, S.num),
      F(`$P${rw3}+$Q${rw3}+$R${rw3}`, S.totNum),
      F(`IF($S${rw3}=0,0,$R${rw3}/$S${rw3})`, S.pct),
    ]);
  }

  const rTot = s4.add([
    C('', S.totTxt),
    C('TỔNG QUỸ LƯƠNG THÁNG', S.totTxt),
    C('', S.totTxt),
    C('', S.totTxt),
    C('', S.totTxt),
    C('', S.totTxt),
    C('', S.totTxt),
    C('', S.totTxt),
    C('', S.totTxt),
    C('', S.totTxt),
    C('', S.totTxt),
    C('', S.totTxt),
    F(`SUM(M${r0i}:M${last})`, S.totNum),
    F(`SUM(N${r0i}:N${last})`, S.totNum),
    F(`SUM(O${r0i}:O${last})`, S.totNum),
    F(`SUM(P${r0i}:P${last})`, S.totNum),
    F(`SUM(Q${r0i}:Q${last})`, S.totNum),
    F(`SUM(R${r0i}:R${last})`, S.totNum),
    F(`SUM(S${r0i}:S${last})`, S.totNum),
    F(`IF($S${3 + Math.max(1, R.ns.length) + 1}=0,0,$R${3 + Math.max(1, R.ns.length) + 1}/$S${3 + Math.max(1, R.ns.length) + 1})`, S.pct),
  ]);
  sh.push(s4);

  /* ---------------- SHEET 5 · SỨC KHOẺ ---------------- */
  const s5 = new WS(N5);
  s5.cols = [46, 20, 18, 18, 34];
  s5.add([C('SỨC KHOẺ QUỸ LƯƠNG', S.title)]);
  s5.merge(1, 0, 1, 4);
  s5.add([C('Toàn bộ số ở đây liên kết sống với các sheet trước.', S.note)]);
  s5.merge(2, 0, 2, 4);
  s5.add([C('Chỉ số', S.hdrL), C('Giá trị', S.hdr), C('Ngưỡng khoẻ', S.hdr), C('Ngưỡng cảnh báo', S.hdr), C('Đánh giá', S.hdrL)]);

  const T = rTot;
  s5.add([C('Quỹ lương cứng (P1 + P2)', S.txt), F(`${Q4}$P$${T}+${Q4}$Q$${T}`, S.num), C('', S.txt), C('', S.txt), C('Trả đều hàng tháng dù bán được hay không', S.txt)]);
  s5.add([C('Quỹ thưởng hiệu quả', S.txt), F(`${Q4}$R$${T}`, S.num), C('', S.txt), C('', S.txt), C('Co giãn theo lãi gộp thực tế', S.txt)]);
  s5.add([C('TỔNG QUỸ LƯƠNG THÁNG', S.totTxt), F(`${Q4}$S$${T}`, S.totNum), C('', S.totTxt), C('', S.totTxt), C('', S.totTxt)]);
  s5.add([C('Doanh thu tháng', S.txt), F(`${Q1}$B$5`, S.num), C('', S.txt), C('', S.txt), C('', S.txt)]);
  s5.add([C('Lãi gộp tháng', S.txt), F(`${Q1}$E$18`, S.num), C('', S.txt), C('', S.txt), C('', S.txt)]);
  s5.add([
    C('Biên lãi gộp bình quân', S.txt),
    F(`${Q1}$C$18`, S.pct),
    C(0.20, S.pct),
    C(0.15, S.pct),
    F('IF($B$9>=0.2,"Khoẻ",IF($B$9>=0.15,"Chấp nhận được","Quá mỏng, xem lại cơ cấu hàng"))', S.txt),
  ]);
  s5.add([
    C('Quỹ lương / doanh thu', S.txt),
    F('IF($B$7=0,0,$B$6/$B$7)', S.pct),
    C(0.10, S.pct),
    C(0.14, S.pct),
    F('IF($B$10<=$C$10,"Khoẻ",IF($B$10<=$D$10,"Sát ngưỡng","Vượt sức quầy"))', S.txt),
  ]);
  s5.add([
    C('Quỹ lương / lãi gộp', S.txt),
    F('IF($B$8=0,0,$B$6/$B$8)', S.pct),
    C(0.45, S.pct),
    C(0.60, S.pct),
    F('IF($B$11<=$C$11,"Khoẻ",IF($B$11<=$D$11,"Sát ngưỡng","Vượt sức quầy"))', S.txt),
  ]);
  s5.add([C('Số người trong bảng lương', S.txt), C(R.soNguoi, S.num), C('', S.txt), C('', S.txt), C('', S.txt)]);
  s5.add([
    C('Doanh thu mỗi người', S.txt),
    F('IF($B$12=0,0,$B$7/$B$12)', S.num),
    C(SALARY_LIB.nguong.dtNguoiTot * 1e6, S.num),
    C(SALARY_LIB.nguong.dtNguoiXau * 1e6, S.num),
    F('IF($B$13>=$C$13,"Năng suất tốt",IF($B$13>=$D$13,"Trung bình","Thấp, cân nhắc giảm người"))', S.txt),
  ]);
  s5.add([C('Thu nhập bình quân mỗi người', S.txt), F('IF($B$12=0,0,$B$6/$B$12)', S.num), C('', S.txt), C('', S.txt), C('', S.txt)]);
  s5.add([
    C('Tỷ trọng thưởng trong thu nhập', S.txt),
    F('IF($B$6=0,0,$B$5/$B$6)', S.pct),
    C(0.12, S.pct),
    C(0.45, S.pct),
    F('IF($B$15<$C$15,"Thưởng quá nhỏ, mất động lực",IF($B$15<=$D$15,"Cân đối","Thu nhập quá bấp bênh"))', S.txt),
  ]);
  s5.add([C('Chi phí cố định khác', S.txt), F(`${Q1}$B$11`, S.num), C('', S.txt), C('', S.txt), C('Mặt bằng, điện nước, phần mềm', S.txt)]);
  s5.add([
    C('LỢI NHUẬN TRƯỚC THUẾ ƯỚC TÍNH', S.totTxt),
    F('$B$8-$B$6-$B$16', S.totNum),
    C('', S.totTxt),
    C('', S.totTxt),
    F('IF($B$17<=0,"Đang lỗ, phải chỉnh ngay",IF($B$17<$B$8*0.15,"Mỏng","Ổn"))', S.totTxt),
  ]);
  s5.add([
    C('Doanh thu hoà vốn — trả lương cứng & phí cố định', S.txt),
    F('IF($B$9=0,0,($B$4+$B$16)/$B$9)', S.num),
    C('', S.txt),
    C('', S.txt),
    C('Dưới mức này là ăn vào vốn', S.txt),
  ]);
  s5.add([
    C('Doanh thu hoà vốn — trả đủ cả thưởng', S.txt),
    F('IF($B$9=0,0,($B$6+$B$16)/$B$9)', S.num),
    C('', S.txt),
    C('', S.txt),
    C('', S.txt),
  ]);
  sh.push(s5);

  /* ---------------- SHEET 6 · QUY CHẾ BẰNG LỜI ---------------- */
  const s6 = new WS(N6);
  s6.cols = [112];
  s6.add([C('QUY CHẾ LƯƠNG THƯỞNG QUẦY THUỐC', S.title)]);
  s6.add([C('Bản nháp quy chế chuẩn bị ban hành cho cơ sở.', S.note)]);
  s6.add([]);
  s6.add([C('ĐIỀU 1. THU NHẬP MỘT NGƯỜI GỒM NHỮNG GÌ', S.h2)]);
  s6.add([C(`Thu nhập tháng = P1 lương vị trí${I.mo === '3P' ? ' + P2 phụ cấp năng lực' : ''} + ${I.mo === '3P' ? 'P3' : 'P2'} thưởng hiệu quả`, S.sub)]);
  s6.add([
    C(
      `P1 — Lương vị trí: Trả cho chỗ ngồi và bậc, tính từ mức lương tối thiểu vùng ${fmtMoney(R.LTTV)} nhân hệ số vị trí, hệ số bậc và mức chi trả ${I.mct}%.`,
      S.wrap
    ),
  ]);
  s6.add([]);
  s6.add([C('ĐIỀU 2. QUỸ THƯỞNG SINH RA TỪ ĐÂU', S.h2)]);
  s6.add([
    C(
      `Quỹ thưởng tháng = Lãi gộp nhóm 1 × ${fmtPercent(I.rate[0], 1)} + Lãi gộp nhóm 2 × ${fmtPercent(I.rate[1], 1)} + Lãi gộp nhóm 3 × ${fmtPercent(I.rate[2], 1)}.`,
      S.sub
    ),
  ]);
  s6.add([]);
  s6.add([C('ĐIỀU 3. HAI KHOÁ AN TOÀN BẢO VỆ QUỸ THƯỞNG', S.h2)]);
  s6.add([C('Khoá 1 — Sản lượng: Doanh thu tháng đạt từ 85% mức giao trở lên. Nếu dưới 85%, quỹ thưởng bị phạt nhân hệ số 0,7.', S.sub)]);
  s6.add([C(`Khoá 2 — Chất lượng lãi: Biên lãi gộp thực tế không thấp hơn kế hoạch quá 1,5 điểm %, tức không dưới ${fmtPercent(Math.max(0, R.bien - 1.5))}. Không đạt thì quỹ thưởng nhân 0,8.`, S.sub)]);
  sh.push(s6);

  /* ---------------- SHEET 7 · THẺ ĐIỂM KPI ---------------- */
  const s7 = new WS(N7);
  s7.cols = [58, 13, 15, 17, 30];
  s7.add([C('THẺ ĐIỂM KPI CHẤM HÀNG THÁNG', S.title)]);
  s7.merge(1, 0, 1, 4);
  s7.add([C('Thang điểm 100 quy đổi sang hệ số thưởng.', S.note)]);
  s7.merge(2, 0, 2, 4);
  const bo = [
    ['A. TUYẾN BÁN HÀNG', SALARY_LIB.kpiBan],
    ['B. KHO VẬN', SALARY_LIB.kpiKho],
    ['C. KẾ TOÁN', SALARY_LIB.kpiKeToan],
  ];
  for (let b = 0; b < bo.length; b++) {
    s7.add([]);
    const rh = s7.add([C(bo[b][0], S.h2)]);
    s7.merge(rh, 0, rh, 4);
    s7.add([C('Chỉ tiêu', S.hdrL), C('Trọng số', S.hdr), C('Mức đạt (0-100)', S.hdr), C('Điểm thành phần', S.hdr), C('Ghi chú cách đo', S.hdrL)]);
    const r1 = s7.at() + 1;
    for (let i = 0; i < bo[b][1].length; i++) {
      const rw = s7.at() + 1;
      s7.add([C(bo[b][1][i][0], S.txt), C(bo[b][1][i][1] / 100, S.pct), C(85, S.inNum), F(`$B${rw}*$C${rw}`, S.dec1), C('', S.txt)]);
    }
    const r2 = s7.at();
    s7.add([C('TỔNG ĐIỂM KPI', S.totTxt), F(`SUM(B${r1}:B${r2})`, S.pct), C('', S.totTxt), F(`SUM(D${r1}:D${r2})`, S.totNum), C('Điền số này vào bảng lương', S.totTxt)]);
  }
  sh.push(s7);

  const blob = xlsxBuild(sh);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 1500);

  return true;
}
